import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Client } from '../entities/client';
//import {AuthenticationToken} from '../entities/credentials';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  environmentName = '';
  WSIdentityUrl = '';
  constructor(private http: HttpClient) {
    this.WSIdentityUrl = environment.WSIdentityUrl;
    this.environmentName = environment.environmentName;
  }
  GetClientByAuthId(AuthId): Observable<Client> {
    const path =
      this.WSIdentityUrl + 'api/Login/LoginByAuthID?AuthId=' + AuthId;
    return this.http.get<Client>(path);
  }
  GetClientByUserName(UserName): Observable<Client> {
    const path =
      this.WSIdentityUrl +
      'api/clients/GetClientByUserName?UserName=' +
      UserName;
    return this.http.get<Client>(path);
  }
  AuthenticateUser(client: Client): Observable<Client> {
    const path = this.WSIdentityUrl + 'api/Login/AuthenticateUser';
    return this.http.post<Client>(path, client);
  }
}
